var map = {
	"./Alpha Store/01-alpha-store-itu-apa.md": 154,
	"./Alpha Store/02-foto-di-toko.md": 155,
	"./Alpha Store/03-ngumpul-di-kyou.md": 156,
	"./Alpha Store/04-boleh-ngga-sih-kalau-ke-toko-fisiknya-nanti-liat-dulu.md": 157,
	"./Alpha Store/06-pembayaran-di-toko-fisik.md": 158,
	"./Alpha Store/07-po-bo-di-toko-fisik.md": 159,
	"./Alpha Store/08-ambil-barang-di-toko.md": 160,
	"./Alpha Store/09-review-space.md": 161,
	"./Alpha Store/10-beli-di-toko-fisik-dan-klaim.md": 162,
	"./Call Service/01-kyou-punya-layanan-telepon.md": 163,
	"./Call Service/02-bedanya-telepon-dan-chat.md": 164,
	"./Call Service/03-kenapa-tidak-langsung-dijawab.md": 165,
	"./Call Service/04-jawaban-menyusul-berapa-lama.md": 166,
	"./Call Service/05-memastikan-panggilan-asli-dari-kyou.md": 167,
	"./Call Service/06-call-terputus.md": 168,
	"./Call Service/07-chat-catatan-setelah-telepon.md": 169,
	"./Call Service/08-minta-ditelepon-di-waktu-tertentu.md": 170,
	"./Call Service/09-kenapa-cs-konfirmasi-ke-divisi-lain.md": 171,
	"./Call Service/10-perlu-mengulang-cerita-di-chat.md": 172,
	"./Dana dan Refund/01-apa-itu-saldo-refund.md": 173,
	"./Dana dan Refund/02-tarik-saldo-refund-jadi-uang.md": 174,
	"./Dana dan Refund/03-masa-berlaku-saldo-refund.md": 175,
	"./Dana dan Refund/04-pakai-saldo-refund-untuk-cicilan.md": 176,
	"./Dana dan Refund/05-tukar-item-selisih-harga.md": 177,
	"./Dana dan Refund/06-berapa-lama-proses-refund.md": 178,
	"./Dana dan Refund/07-refund-kembali-ke-mana.md": 179,
	"./Friendship Points/01-kyou-friendship-point-tuh-apa-sih-dan-gimana-cara-pakenya.md": 180,
	"./Friendship Points/02-aku-mau-cek-Friendship-point-aku-di-kyou-gimana-caranya-ya.md": 181,
	"./Friendship Points/03-bagaimana-cara-mendapatkan-friendship-points.md": 182,
	"./Friendship Points/04-bisakah-friendship-point-dipakai-untuk-mendapatkan-potongan-harga.md": 183,
	"./Friendship Points/05-apa-saja-syarat-dan-ketentuan-friendship-point-exchange.md": 184,
	"./Friendship Points/06-apakah-friendship-point-exchange-bisa-digunakan-di-website.md": 185,
	"./Friendship Points/07-gimana-cara-pakai-friendship-point-exchange.md": 186,
	"./Friendship Points/08-kapan-batas-waktu-penggunaan-friendship-point.md": 187,
	"./Friendship Points/09-apakah-friendship-points-dapat-dikirimkan-ke-pengguna-lain.md": 188,
	"./Friendship Points/10-apa-yang-bisa-aku-lakukan-ketika-friendship-point-mengalami-bug.md": 189,
	"./Klaim dan Retur/01-syarat-video-unboxing.md": 190,
	"./Klaim dan Retur/02-batas-waktu-klaim.md": 191,
	"./Klaim dan Retur/03-buka-paket-tanpa-rekam.md": 192,
	"./Klaim dan Retur/04-syarat-foto-pendukung.md": 193,
	"./Klaim dan Retur/05-kenapa-batas-klaim-ureq-lebih-pendek.md": 194,
	"./Klaim dan Retur/06-paket-datang-rusak-berat.md": 195,
	"./Klaim dan Retur/07-alur-retur-dan-lama-prosesnya.md": 196,
	"./Klaim dan Retur/08-ongkir-retur-siapa-yang-bayar.md": 197,
	"./Klaim dan Retur/09-barang-pengganti-tidak-tersedia.md": 198,
	"./Klaim dan Retur/10-barang-retur-tidak-sesuai-dokumentasi.md": 199,
	"./Klaim dan Retur/11-hari-kerja-dan-hari-operasional.md": 200,
	"./Legal dan Lintas Kanal/01-beli-lewat-marketplace.md": 201,
	"./Legal dan Lintas Kanal/02-batas-tanggung-jawab-kyou.md": 202,
	"./My Account/00-halo-kyou-aku-pertama-kali-ke-website-nih-kalau-mau-belanja-harus-buat-akun-yah.md": 203,
	"./My Account/01-kyou-aku-mau-ganti-alamat-karena-udah-pindah-caranya-gimana.md": 204,
	"./My Account/02-kyou-aku-jarang-cek-whatsapp-apakah-ada-alternatif-kyou-infokan-update-orderku-lewat-mana-ya.md": 205,
	"./My Account/03-kyou-aku-mau-ganti-password-biar-ga-dibobol-orang-nakal-bisa-ngga.md": 206,
	"./My Account/04-kyou-aku-mau-ganti-nomor-hp-yang-dapat-chat-notifikasi-dari-kyou-bisa-ngga.md": 207,
	"./My Account/05-kyou-email-aku-ganti-nih-gimana-cara-gantinya-sekalian-mau-ganti-nama-juga-bisa-ga.md": 208,
	"./My Account/06-saya-lupa-password.md": 209,
	"./My Account/07-saya-lupa-username.md": 210,
	"./Order & Payments/00-cara-order.md": 211,
	"./Order & Payments/01-metode-pembayaran-yang-diterima.md": 212,
	"./Order & Payments/02-saya-tidak-punya-atm.md": 213,
	"./Order & Payments/03-status-belum-terbayar.md": 214,
	"./Order & Payments/04-perbedaan-order-id-dan-paycode.md": 215,
	"./Order & Payments/05-pembayaran-dengan-kartu-kredit.md": 216,
	"./Order & Payments/06-pembayaran-dengan-paypal.md": 217,
	"./Order & Payments/07-perbedaan-laman-transaction-dengan-order-history.md": 218,
	"./Order & Payments/08-pembayaran-qris-bermasalah.md": 219,
	"./Order & Payments/09-pembayaran-va-bermasalah.md": 220,
	"./Order & Payments/10-ubah-metode-pembayaran.md": 221,
	"./Order & Payments/11-kyou-cara-bayar-via-e-commerce-bagaimana-ya.md": 222,
	"./Order & Payments/12-membayar-lewat-ecommerce.md": 223,
	"./Order & Payments/13-kyou-tapi-di-varian-link-tokopedia-dan-shopee-ada-link-varian-yang-sesuai-sama-nominal-total-ordernya-kenapa-gak-pakai-itu-aja.md": 224,
	"./Order & Payments/14-kyou-kalau-aku-mau-split-pay-transfer-agar-nominal-check-out-dari-e-commerce-nya-gak-terlalu-besar-bisa-apakah-bisa-dan-mau-dikirim-via-e-commerce-agar-hemat-ongkir.md": 225,
	"./Order & Payments/15-tapi-kyou-di-web-aku-udah-pilih-pengiriman-apakah-pelunasannya-bakal-kena-ongkir-double.md": 226,
	"./Order & Payments/16-tapi-kyou-aku-order-fullpay-po-tetap-bayar-double-ongkirnya-karena-bayar-ongkir-di-e-commerce-sama-di-web-kyou-gimana-dong.md": 227,
	"./Order & Payments/17-kyou-kok-aku-di-tagih-lagi-karena-kurang-bayar-padahal-aku-udah-bayar-sesuai-info-di-web-lho.md": 228,
	"./Order & Payments/18-telat-lunasin-uang-hangus.md": 229,
	"./Order & Payments/19-perpanjangan-pelunasan-berapa-kali.md": 230,
	"./Order & Payments/20-chat-pembukaan-ulang-order-asli-atau-penipuan.md": 231,
	"./Order & Payments/21-batas-respon-dan-batas-pelunasan.md": 232,
	"./Pengiriman dan Resi/01-di-mana-lihat-nomor-resi.md": 233,
	"./Pengiriman dan Resi/02-notifikasi-pengiriman-artinya-apa.md": 234,
	"./Pengiriman dan Resi/03-notifikasi-pickup-di-store.md": 235,
	"./Pengiriman dan Resi/04-paket-sudah-dikirim-belum-sampai.md": 236,
	"./Pre Order/00-pre-order-itu-maksudnya-gimana-sih-kyou.md": 237,
	"./Pre Order/01-late-pre-order-itu-maksudnya-gimana-kyou.md": 238,
	"./Pre Order/02-aku-punya-voucher-diskon-pre-order-cara-pakainya-gimana-kyou.md": 239,
	"./Pre Order/03-terus-gimana-sih-cara-dapetin-voucher-diskonnya-kyou.md": 240,
	"./Pre Order/04-udah-pre-order-nih-kyou-itemnya-sampai-kapan-ya.md": 241,
	"./Pre Order/05-aku-dapat-tagihan-pelunasan-nih-kyou-batas-lunasinnya-kapan-ya.md": 242,
	"./Pre Order/06-barang-yang-aku-incar-ternyata-ada-late-pre-order-nya-nih-kyou-sisa-slotnya-berapa-ya.md": 243,
	"./Pre Order/07-kyou-udah-order-nih-tapi-itu-beneran-ongkos-kirimnya-0.md": 244,
	"./Pre Order/08-udah-dp-pre-order-nih-kyou-nanti-kalau-mau-cicil-boleh-ngga.md": 245,
	"./Pre Order/09-kyou-ini-item-pre-order-saya-udah-lewat-dari-estimasi-tapi-kok-masih-belum-datang.md": 246,
	"./Pre Order/10-kyou-aku-ngga-jadi-koleksi-nih-pre-orderanku-boleh-dipindahin-ke-temenku-nggak.md": 247,
	"./Pre Order/11-kyou-amit-amit-nih-ya-misal-kyou-gagal-dapetin-itemnya-apa-yang-terjadi.md": 248,
	"./Pre Order/12-kalau-sudah-pre-order-boleh-cancel-nggak-sih-kyou.md": 249,
	"./Pre Order/13-pre-order-terlalu-lama.md": 250,
	"./Pre Order/14-ganti-orderan.md": 251,
	"./Pre Order/15-aku-pindah-alamat-namun-item-po-ku-belum-sampai-gimana-cara-ubah-alamat-pengirimannya.md": 252,
	"./Pre Order/16-box-po-kurang-bagus.md": 253,
	"./Pre Order/17-menolak-tambahan-biaya-po.md": 254,
	"./Pre Order/18-bulan-rilis-bukan-bulan-sampai.md": 255,
	"./Pre Order/19-kyou-menunda-refund-keterlambatan.md": 256,
	"./Pre Order/20-refund-satu-item-po.md": 257,
	"./Product Inquiry/01-produk-cacat.md": 258,
	"./Product Inquiry/02-nendoroidku-ada-cacat-atau-part-kurang.md": 259,
	"./Product Inquiry/03-figmaku-ada-cacat-atau-part-kurang.md": 260,
	"./Product Inquiry/04-scale-figureku-ada-cacat-atau-part-kurang.md": 261,
	"./Product Inquiry/05-moderoidku-ada-cacat-atau-part-kurang.md": 262,
	"./Product Inquiry/06-rusak-tidak-disengaja.md": 263,
	"./Product Inquiry/07-dear-gsc.md": 264,
	"./Product Inquiry/08-produk-non-gsc-cacat.md": 265,
	"./Product Inquiry/09-box-penyok.md": 266,
	"./Product Inquiry/10-barang-hilang-oleh-ekspedisi.md": 267,
	"./Product Inquiry/11-blokees-ada-cacat-atau-part-kurang.md": 268,
	"./Product Inquiry/12-cacat-kecil-dan-joint-longgar.md": 269,
	"./Product Inquiry/13-jalur-klaim-ke-manufaktur.md": 270,
	"./Ready Stock/01-apa-itu-ready-stock.md": 271,
	"./Ready Stock/02-restock.md": 272,
	"./Ready Stock/03-voucher-ready-stock.md": 273,
	"./Ready Stock/04-estimasi-item.md": 274,
	"./Ready Stock/05-ongkir-item-ready.md": 275,
	"./Ready Stock/06-order-belum-dikirim-3-hari.md": 276,
	"./Ready Stock/07-order-belum-dikirim-5-hari.md": 277,
	"./Ready Stock/08-item-ready-yang-dipesan-sold-out.md": 278,
	"./Ready Stock/09-pembatalan.md": 279,
	"./Ready Stock/10-takut-barang-palsu.md": 280,
	"./Ready Stock/11-figure-ngga-ada-foto-box.md": 281,
	"./Ready Stock/12-item-diskon.md": 282,
	"./Ready Stock/13-packing-extra.md": 283,
	"./Ready Stock/14-order-sameday-belum-sampai-hingga-malam.md": 284,
	"./Ready Stock/15-item-tidak-sesuai-pesanan.md": 285,
	"./Ready Stock/16-standar-kondisi-barang-dan-box.md": 286,
	"./Ready Stock/17-stok-fisik-tidak-ketemu.md": 287,
	"./Ready Stock/18-gudang-pengirim-dan-ongkir.md": 288,
	"./Ready Stock/19-wipeout-dan-wakeari.md": 289,
	"./Ready Stock/20-blind-box-dapat-karakter-lain.md": 290,
	"./Unique Request/01-apa-yang-dimaksud-dengan-unique-request.md": 291,
	"./Unique Request/02-berapa-waktu-yang-dibutuhkan-agar-item-unique-request-sampai.md": 292,
	"./Unique Request/03-apakah-harga-sudah-final.md": 293,
	"./Unique Request/04-mengapa-harga-unique-request-belum-final.md": 294,
	"./Unique Request/05-detil-perhitungan-harga-unique-request.md": 295,
	"./Unique Request/06-pengertian-toleransi-berat.md": 296,
	"./Unique Request/07-bukti-dibelanjakan.md": 297,
	"./Unique Request/08-item-berbahaya.md": 298,
	"./Unique Request/09-unique-request-terlalu-lama.md": 299,
	"./Unique Request/10-unique-request-gagal-parsial.md": 300,
	"./Unique Request/11-aku-pindah-alamat-namun-item-ureq-ku-belum-sampai-gimana-cara-ubah-alamat-pengirimannya.md": 301,
	"./Unique Request/12-harga-unique-request.md": 302,
	"./Unique Request/13-proteksi-tambahan.md": 303,
	"./Unique Request/14-berat-terhitung.md": 304,
	"./Unique Request/15-toleransi-berat-ditentukan-dari-apa.md": 305,
	"./Unique Request/16-tarif-kelebihan-berat.md": 306,
	"./Unique Request/17-biaya-impor-elektronik-dan-tekstil.md": 307,
	"./Unique Request/18-link-habis-stok-produk-pengganti.md": 308,
	"./Unique Request/19-kapan-bayar-biaya-tambahan.md": 309,
	"./Unique Request/20-tambahan-biaya-kecil-tanpa-konfirmasi.md": 310,
	"./Unique Request/21-menolak-penyesuaian-biaya-impor.md": 311,
	"./Unique Request/22-selisih-harga-produk-pengganti.md": 312,
	"./Unique Request/23-barang-beda-dari-foto-link.md": 313,
	"./Unique Request/24-ongkir-lokal-jepang.md": 314,
	"./Unique Request/25-kyou-jasa-titip-beli.md": 315,
	"./Unique Request/26-banding-klaim-ditolak.md": 316,
	"./Unique Request/27-link-wajib-proteksi-tambahan.md": 317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;